const ROOTS_AUTH = 'auth';
const ROOTS_PROJECTS = 'projects';
const ROOTS_PROJECT = 'project';
const ROOTS_USERS = 'users';
const ROOTS_BILLING = 'billing';
const ROOTS_EXTERNAL = 'external';
const ROOTS_STATISTICS = 'statistics';
const ROOTS_PLAYGROUND = 'playground/project';
const KNOWLEDGE_BASE = 'knowledge_bases';
const SETTINGS_BASE = 'settings';
export const API_VERSION = {
  V1: 'v1',
  V2: 'v2',
};
export const ACCOUNTS_URL = 'accounts/';
export const SSO_REGISTRATION_CONFIRM = 'auth/registration/confirm';

export const PATH_AUTH_API = {
  ROOT: ROOTS_AUTH,
  TOKEN: `${ROOTS_AUTH}/token`,
  TOKEN_GOOGLE: `${ROOTS_AUTH}/token/google`,
  LOGOUT: `${ROOTS_AUTH}/logout`,
  TOKEN_REFRESH: `${ROOTS_AUTH}/token/refresh`,
  RESET_PASSWORD: `${ROOTS_AUTH}/reset-password`,
  RESET_PASSWORD_CONFIRM: `${ROOTS_AUTH}/reset-password/confirm`,
  REGISTRATION_CONFIRM: `${ROOTS_AUTH}/registration/confirm`,
};

export const PATH_PROJECTS_API = {
  ROOT: ROOTS_PROJECTS,
  ALL: `${ROOTS_PROJECTS}/all`,
  DEMO_MODE: `${ROOTS_PROJECTS}/project/demo-mode`,
  TEAM_MEMBERS: `team-members`,
  NEW_LIMIT: `new-limit`,
  INTEGRATIONS: `integrations`,
  INTEGRATIONS_ZENDESK_EMAIL_AUTO_SETUP: `zendesk-email/auto-setup`,
  INTEGRATIONS_ZENDESK_EMAIL_STATUS_FIELDS: `zendesk-email/fields/statuses`,
  INTEGRATIONS_ZENDESK_EMAIL_ASSIGNEE_FIELDS: `zendesk-email/fields/assignees`,
  INTEGRATIONS_ZENDESK_EMAIL_GROUPS_FIELDS: `zendesk-email/fields/groups`,
  INTEGRATIONS_ZENDESK_OAUTH_AUTHORIZE_URL: 'oauth/authorize-url',
  INTEGRATIONS_FRESHDESK_EMAIL_AGENTS: `freshdesk-email/agents`,
  INTEGRATIONS_FRESHDESK_EMAIL_GROUPS: `freshdesk-email/groups`,
  INTEGRATIONS_FRESHDESK_EMAIL_AUTO_SETUP: `freshdesk-email/auto-setup`,
  INTEGRATIONS_ZENDESK_CHAT_AUTO_SETUP: `zendesk-chat/auto-setup`,
  INTEGRATIONS_ZOHO_SALES_IQ_SETUP: `zoho-salesiq/setup`,
  INTEGRATIONS_ZOHO_DESK_SETUP: `zoho-desk/setup`,
  ZENDESK_CHAT_WIDGETS: `zendesk-chat/widgets`,
  FILES: `files`,
  ADD_DOCUMENT: `documents`,
  CHATS: `chats`,
};

export const PATH_KNOWLEDGE_BASE_API = {
  ROOT: KNOWLEDGE_BASE,
  ASSIGN: 'knowledge-base/assign',
  ASSIGN_V2: 'knowledge-bases/assign',
  UNASSIGN: 'knowledge-base/unassign',
  UNASSIGN_V2: 'knowledge-bases/unassign',
  COLLECTOR_ZENDESK_OAUTH_AUTHORIZE_URL: 'zendesk-oauth/authorize-url',
};

export const PATH_BILLING_API = {
  ROOT: ROOTS_BILLING,
  PAYMENTS: `${ROOTS_BILLING}/payments`,
  PLANS_ALL: `${ROOTS_BILLING}/plans/all`,
  PAYMENT_METHODS: `${ROOTS_BILLING}/payment-methods`,
  PAYMENT_METHOD_DEFAULT: `${ROOTS_BILLING}/payment-methods/default`,
  CREATE_SUBSCRIPTION: `${ROOTS_BILLING}/create-subscription`,
  CHANGE_SUBSCRIPTION: `${ROOTS_BILLING}/change-subscription`,
  CANCEL_SUBSCRIPTION: `${ROOTS_BILLING}/cancel-subscription`,
  INVOICE_PDF: `${ROOTS_BILLING}/receipt`,
  SUBSCRIPTION_PERMISSION_GET: `${ROOTS_BILLING}/project-plans/subscription/permission/get`,
  SUBSCRIPTION_PERMISSION_SET: `${ROOTS_BILLING}/project-plans/subscription/permission/set`,
  CREATE_PAYMENT_INTENT: `${ROOTS_BILLING}/payment-intent/create`,
  CHECKOUT_SESSION: `${ROOTS_BILLING}/checkout/session`,
};

export const PATH_USERS_API = {
  ROOT: ROOTS_USERS,
  ME: `${ROOTS_USERS}/me`,
  ALL: `${ROOTS_USERS}/all`,
  CREATE: `${ROOTS_USERS}/create`,
  REGISTRATION: `${ROOTS_USERS}/registration`,
  RESEND_VERIFICATION_EMAIL: `${ROOTS_USERS}/registration/token/resend`,
  VALIDATE_FIELDS: `${ROOTS_USERS}/registration/validate/fields`,
  UPDATE: `/update`,
  DELETE: `/delete`,
};

export const PATH_ANALYTICS_API = {
  COAGENT: `${ROOTS_EXTERNAL}/statistics`,
  COCUSTOMER: {
    ROOT: `${ROOTS_STATISTICS}/cocustomer`,
    TIME_SERIES: `${ROOTS_STATISTICS}/cocustomer/timeseries`,
    AGGREGATED: `${ROOTS_STATISTICS}/cocustomer/aggregated`,
    CHATS_COUNT: `${ROOTS_STATISTICS}/cocustomer/chats/count`,
  },
  SUMMARY: `${ROOTS_STATISTICS}/summary`,
};

export const PATH_PLAYGROUND_API = {
  ROOT: ROOTS_PLAYGROUND,
  CHAT: '/chat',
  MESSAGES: '/messages',
  callback: '/callback',
};

export const PATH_CONFIGURATION_API = {
  ROOT: SETTINGS_BASE,
  ROOT_PROJECT: ROOTS_PROJECT,
  ROOT_PROJECTS: ROOTS_PROJECTS,
  DEFAULT_TEMPLATE_FIELDS: `${SETTINGS_BASE}/templates/default`,
  CUSTOM_TEMPLATES: `${SETTINGS_BASE}/templates/custom`,
};
